// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/About.tsx
// Version: v1.0.1
// Description: Über uns-Seite (Placeholder)

// Weitere Komponenten können hier importiert werden

const About = () => {
  return (
    <>
      {/* Komponenten */}
      
      
      {/* Weitere Sections können hier hinzugefügt werden */}
      <section className="py-16">
        <div className="max-w-[1700px] mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-8">
            Willkommen bei ESTATA about/
          </h2>
          <p className="text-center text-gray-600 max-w-3xl mx-auto">
            Ihre Content hier...
          </p>
        </div>
      </section>
    </>
  );
};

export default About;